import Loading from '../misc/Loading';
import React from 'react';
import { ModuleInstanceStatus, ModuleInstanceStatusSeverity } from '../../models/CoreModels';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';


interface ModulePhaseStatusProps {
    status?: ModuleInstanceStatus,
    severity?: ModuleInstanceStatusSeverity
}

export const ModulePhaseStatusSeverityIcon = (props: ModulePhaseStatusProps) => {

    const { t } = useTranslation(['common', 'configuration']);

    const getPhaseIcon = (status: ModuleInstanceStatus | undefined, severity: ModuleInstanceStatusSeverity | undefined) => {
        if (status === ModuleInstanceStatus.Started) {
            return (
                <span className="icon" title={t('instancePhase.getStatus.started', { ns: 'configuration' })}>
                    <Loading className="phase-spinner" />
                </span>
            );
        }

        if (status === ModuleInstanceStatus.Cancelled) {
            return <span className="icon" title={t('instancePhase.getStatus.cancelled', { ns: 'configuration' })} > <FontAwesomeIcon icon="xmark" className="icon_error" /> </span>;
        }

        if (status === ModuleInstanceStatus.FinishedInQuarantine && severity === ModuleInstanceStatusSeverity.Critical) {
            return <span className="icon" title={t('instancePhase.getStatus.quarantine', { ns: 'configuration' })}> <FontAwesomeIcon icon="circle-radiation" className="icon_error" /> </span>;
        }
        
        switch (severity) {
            case ModuleInstanceStatusSeverity.Ok: return <span className="icon" title={t('instancePhase.getStatus.completed', { ns: 'configuration' })}> <FontAwesomeIcon icon="check-circle" className="icon_ok" /></span>;
            case ModuleInstanceStatusSeverity.Error: return <span className="icon"title={t('instancePhase.getStatus.error', { ns: 'configuration' })}><FontAwesomeIcon icon="times-circle" className="icon_error" /></span>;
            case ModuleInstanceStatusSeverity.Critical: return <span className="icon" title={t('instancePhase.getStatus.criticalError', { ns: 'configuration' })}><FontAwesomeIcon icon="record-vinyl" className="icon_critical" /></span>;
            case ModuleInstanceStatusSeverity.Warning: return <span className="icon" title={t('instancePhase.getStatus.warning', { ns: 'configuration' })} ><FontAwesomeIcon icon="exclamation-circle" className="icon_warning" /></span >;
            default: return <span className="icon" title={t('instancePhase.getStatus.undefined', { ns: 'configuration' })}><FontAwesomeIcon icon="question-circle" className="icon_undefined" /></span>;
        }
    }
    return getPhaseIcon(props.status, props.severity);
}
export default ModulePhaseStatusSeverityIcon;